import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config/environment'

// Create axios instance with base configuration
const api = axios.create({
  baseURL: config.ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for cookie-based authentication
})

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to admin login on 401 errors
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

export const adminService = {
  // Admin login
  async login(email, password) {
    try {
      const response = await api.post('/login', {
        email,
        password,
      })
      
      console.log('AdminService login response:', response.data)
      
      // Show success toast with API message
      if (response.data.message) {
        toast.success(response.data.message)
      } else {
        toast.success('Admin login successful!')
      }
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Admin login failed'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Admin register
  async register(adminData) {
    try {
      const response = await api.post('/register', adminData)
      
      if (response.data.message) {
        toast.success(response.data.message)
      } else {
        toast.success('Admin registered successfully!')
      }
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Admin registration failed'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Admin logout
  async logout() {
    try {
      const response = await api.post('/logout')
      
      if (response.data.message) {
        toast.success(response.data.message)
      } else {
        toast.success('Admin logout successful!')
      }
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Admin logout failed'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Get current admin - NOT USED (admin auth uses localStorage instead)
  async getCurrentAdmin() {
    try {
      const response = await api.get('/me')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to get current admin'
      throw new Error(errorMessage)
    }
  },

  // Get all admins
  async getAllAdmins() {
    try {
      const response = await api.get('/')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to get admins'
      throw new Error(errorMessage)
    }
  },

  // Get admin by ID
  async getAdminById(adminId) {
    try {
      const response = await api.get(`/${adminId}`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to get admin'
      throw new Error(errorMessage)
    }
  },

  // Create admin
  async createAdmin(adminData) {
    try {
      const response = await api.post('/', adminData)
      
      if (response.data.message) {
        toast.success(response.data.message)
      } else {
        toast.success('Admin created successfully!')
      }
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to create admin'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Update admin
  async updateAdmin(adminId, updateData) {
    try {
      const response = await api.put(`/${adminId}`, updateData)
      
      if (response.data.message) {
        toast.success(response.data.message)
      } else {
        toast.success('Admin updated successfully!')
      }
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to update admin'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Delete admin
  async deleteAdmin(adminId) {
    try {
      const response = await api.delete(`/${adminId}`)
      
      if (response.data.message) {
        toast.success(response.data.message)
      } else {
        toast.success('Admin deleted successfully!')
      }
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to delete admin'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Change password
  async changePassword(currentPassword, newPassword) {
    try {
      const response = await api.post('/change-password', {
        currentPassword,
        newPassword
      })
      
      if (response.data.message) {
        toast.success(response.data.message)
      } else {
        toast.success('Password changed successfully!')
      }
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to change password'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  }
}
